/*
  @ Enable sound on the video element
*/

const BUTTON = '.js-VideoSound';

class VideoSound {
  constructor() {
    if(!document.querySelector(BUTTON)) {
      return
    }

    document.querySelector(BUTTON).addEventListener("click", this.clickHandler);
  }

  clickHandler = (e) => {
    const target = document.querySelector(e.currentTarget.getAttribute('data-target'))

    if(target.muted) {
      e.currentTarget.innerHTML = 'Sound off';
      target.muted = false;
    } else {
      e.currentTarget.innerHTML = 'Sound on';
      target.muted = true;
    }

    e.preventDefault()
  };
}

new VideoSound();
